import { request } from "./base";

export const getDealerModels = (dealers: string[]) =>
  request(`/dealer-models`, {
    method: "POST",
    body: JSON.stringify({ dealers: dealers }),
  }).then(res => res.json());
